import { DefaultTheme } from "styled-components";

import defaultTheme from "./defaultTheme";

const theme: DefaultTheme = defaultTheme;

export { theme };
 